const url = '/email-templates';
const Provider = 'EmailTemplates';
const dbModel = 'EmailTemplates';

export { url, Provider, dbModel };
